const INGREDIENT_PHRASE_TYPES = {
  NEGATIVE_SYNONYM: 'NEGATIVE_SYNONYM',
  PAIRING: 'PAIRING',
  REFERENCING: 'REFERENCING',
}

export default INGREDIENT_PHRASE_TYPES
